<template>
    <v-data-table
        :headers="headers"
        disable-filtering
        disable-sort
        :items="errors"
        item-key="row"
        items-per-page="5"
    >
    </v-data-table>
</template>

<script>
export default {
    name: "SocialDebtorsUploadError",
    props: {
        errors: {
            type: Array,
            default: () => []
        }
    },
    computed: {
        headers(){
            return [
                { text: 'Строка', value: 'row' },
                { text: 'Ошибка', value: 'errors' },
            ];
        }
    }
}
</script>

<style scoped>

</style>